/* eslint-disable max-len */
import jDashSiswa from '@/views/dashboard/jDashSiswa';

import jSiswaList from '@/views/kesiswaan/siswa/jSiswaList';
import jSiswaCreate from '@/views/kesiswaan/siswa/jSiswaCreate';
import jSiswaUpdate from '@/views/kesiswaan/siswa/jSiswaUpdate';
import jSiswaReport from '@/views/kesiswaan/siswa/jSiswaReport';

import jBukuSaku from '@/views/kesiswaan/buku-saku/jBukuSaku';
import jBukuSakuForm from '@/views/kesiswaan/buku-saku/jBukuSakuForm';
import jBukuSakuApp from '@/views/kesiswaan/buku-saku/approver/jBukuSakuApp';
import jBukuSakuFormApp from '@/views/kesiswaan/buku-saku/approver/jBukuSakuFormApp';
import jBukuSakuReport from '@/views/kesiswaan/buku-saku/jBukuSakuReport';

import jEkskulList from '@/views/kesiswaan/ekskul/jEkskulList';
import jEkskulUpdate from '@/views/kesiswaan/ekskul/jEkskulUpdate';
import jEkskulReport from '@/views/kesiswaan/ekskul/jEkskulReport';

import jSuratDispenApp from '@/views/kesiswaan/dispen/jSuratDispenApp';

import jPelanggaran from '@/views/kesiswaan/pelanggaran/jPelanggaran';

import auth from '@/middleware/auth';
import log from '@/middleware/log';

export default [
  {
    path: '/dashboard/siswa',
    name: 'jDashSiswa',
    component: jDashSiswa,
    meta: {
      title: 'Dashboard Kesiswaan',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },

  // Data Siswa --------------------------------------
  {
    path: '/data-siswa',
    name: 'jSiswaList',
    component: jSiswaList,
    meta: {
      title: 'Data Siswa',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/data-siswa/create',
    name: 'jSiswaCreate',
    component: jSiswaCreate,
    meta: {
      title: 'Data Siswa',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/data-siswa/detail/:nis',
    name: 'jSiswaUpdate',
    component: jSiswaUpdate,
    meta: {
      title: 'Data Siswa',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/data-siswa/report',
    name: 'jSiswaReport',
    component: jSiswaReport,
    meta: {
      title: 'Report Siswa',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },

  // Buku Saku Siswa --------------------------------------
  {
    path: '/buku-saku-siswa',
    name: 'jBukuSaku',
    component: jBukuSaku,
    meta: {
      title: 'Buku Saku Siswa',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/buku-saku-siswa/detail/:tahunajaran/:kelas/:nis',
    name: 'jBukuSakuForm',
    component: jBukuSakuForm,
    meta: {
      title: 'Buku Saku Siswa',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/buku-saku-siswa/approver',
    name: 'jBukuSakuApp',
    component: jBukuSakuApp,
    meta: {
      title: 'Buku Saku Siswa',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/buku-saku-siswa/approver/detail/:id/:status',
    name: 'jBukuSakuFormApp',
    component: jBukuSakuFormApp,
    meta: {
      title: 'Data Saku Siswa',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/buku-saku-siswa/report',
    name: 'jBukuSakuReport',
    component: jBukuSakuReport,
    meta: {
      title: 'Buku Saku Siswa',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },

  // Data Ekskul --------------------------------------
  {
    path: '/data-ekskul',
    name: 'jEkskulList',
    component: jEkskulList,
    meta: {
      title: 'Data Siswa',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/data-ekskul/detail/:kode',
    name: 'jEkskulUpdate',
    component: jEkskulUpdate,
    meta: {
      title: 'Data Ekskul',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },

  {
    path: '/approver-dispen',
    name: 'jSuratDispenApp',
    component: jSuratDispenApp,
    meta: {
      title: 'Data Ekskul',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/data-ekskul/report',
    name: 'jEkskulReport',
    component: jEkskulReport,
    meta: {
      title: 'Report Ekstrakulikuler',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },

  // Data Pelanggaran --------------------------------------
  {
    path: '/data-pelanggaran',
    name: 'jPelanggaran',
    component: jPelanggaran,
    meta: {
      title: 'Data Pelanggaran',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/jRouterKesiswaan.js